import { render, staticRenderFns } from "./DeviceDocumentList.vue?vue&type=template&id=f0de87de&scoped=true"
import script from "./DeviceDocumentList.vue?vue&type=script&lang=js"
export * from "./DeviceDocumentList.vue?vue&type=script&lang=js"
import style0 from "./DeviceDocumentList.vue?vue&type=style&index=0&id=f0de87de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0de87de",
  null
  
)

export default component.exports